import SvgIcon from "@mui/material/SvgIcon";

export default props => (
  <SvgIcon viewBox="1 0 12 13" {...props}>
    <path d="M0.895508 12L3.11719 0.652344L6.74023 8.85547L10.4932 0.652344L12.4893 12H10.8555L9.83691 5.62891L6.71289 12.4854L3.67773 5.62207L2.54297 12H0.895508Z" />
  </SvgIcon>
);
